define('C3.ShoppingExtensions.IncomingEquipment.ResultsView'
, 	[
		'c3_shoppingextensions_incomingequipment_resultsview.tpl',
        'Profile.Model',
        //'SC.Configuration',
        'Utils',    
		'SCView',
        'C3.ShoppingExtensions.IncomingEquipment.Collection'
	],
function (
		c3_shoppingextensions_incomingequipment_resultsview_tpl,
        ProfileModel,
       // Configuration,
        Utils,
		SCViewModule,
        IncomingEquipmentCollection
){
	'use strict';

	 var SCView = SCViewModule.SCView;

	  function IncomingEquipmentSearchDetailResultsView (options) {
        SCView.call(this, options);

        this.template = c3_shoppingextensions_incomingequipment_resultsview_tpl;
        this.options = options;
	    this.model = options.model;

    }

    IncomingEquipmentSearchDetailResultsView.prototype = Object.create(SCView.prototype);
    IncomingEquipmentSearchDetailResultsView.prototype.constructor = IncomingEquipmentSearchDetailResultsView;


    IncomingEquipmentSearchDetailResultsView.prototype.render = function () {
        SCView.prototype.render.call(this);

    }

    IncomingEquipmentSearchDetailResultsView.prototype.getContext = function () {

        return {
        	ColumnValues : this.model.get('columns')
        }
    }

    return IncomingEquipmentSearchDetailResultsView
});
